import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { DetailView } from 'src/app/common-components/detail/detail-view';
import { EffectiveUserPreferences } from 'src/app/store/user-preferences/user-preferences';
import { GetUserDetail_user } from '../../user-details/queries/generated/GetUserDetail';
import { UserPreferenceDetailSaveEvent } from '../models/user-preference-detail-form-submit-event';
import { UserPreferenceDetailFormService } from '../services/user-preference-detail-form.service';

@Component({
    selector: 'ndt-user-preference-detail-view',
    styleUrls: ['./user-preference-detail-view.component.scss'],
    templateUrl: './user-preference-detail-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UserPreferenceDetailViewComponent extends DetailView {
   @Output() savePreferences = new EventEmitter<UserPreferenceDetailSaveEvent>();

   @Output() formSaveCancelled = new EventEmitter<void>();

   @Input() callState: CallState;

   @Input() user: GetUserDetail_user;

   form: FormGroup;

   constructor(public formService: UserPreferenceDetailFormService) {
      super();
      this.form = this.formService.form;
   }

   onSubmit(): void {
      if (this.form.valid) {
         const submitEvent = this.getFormSubmittedEvent();
         this.savePreferences.emit(submitEvent);
      }
   }

   onCancel(): void {
      this.formSaveCancelled.emit();
   }

   private getFormSubmittedEvent(): UserPreferenceDetailSaveEvent {
      const userPreference = this.formService.getValue(this.user.userId);
      let userPreferenceFields: (keyof EffectiveUserPreferences)[] = [];
      userPreferenceFields = this.formService.addFieldForDirtyControl(
         userPreferenceFields,
         'useAlternatingRowColors',
         'UseAlternatingRowColors'
      );

      return { userPreference, userPreferenceFields };
   }
}
